<template>
  <div class="container" v-if="user">
    <div class="app-sections">
      <app-section
        v-for="section in sections"
        :currentRoute="currentRoute"
        :section="section"
        :key="section.name"
        :user="user"
      ></app-section>
    </div>

    <div class="settings-section">
      <settings-section :user="user"></settings-section>
    </div>
  </div>
</template>

<script>
import Back from "../../modules/Back";
import Bus from "../../modules/Bus";
import UserSection from "./UserSection";
import AppSection from "./AppSection";
import SettingsSection from "./SettingsSection";
import FindBook from "@/components/Page/FindBook";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";

export default {
  name: "AppBar",
  components: { SettingsSection, AppSection, UserSection, FindBook },
  data: function () {
    return {
      user: null,
      frontendSettings: null,
      allowedCountries: null,
      reviewIssues: null,
      readingLimit: null,
      weeklyReadingLimit: null,
      reviewSearchLimit: null,
      currentRoute: null,
      genres: null,
      languages: null,
      sections: [
        {
          title: "Author",
          name: "author",
          routing: "books",
          icon: "free_breakfast",
          pages: [],
        },
        {
          title: "Reader",
          name: "reader",
          routing: "assignments",
          icon: "book",
          pages: [],
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      showFindBook: "showFindBook",
      showReferProgram: "showReferProgram",
    }),
  },
  methods: {
    loadPages() {
      const books = this.user.books;
      for (const b in books) {
        const book = books[b];
        if (book.status === "Editing") {
          book.route = "edit/" + book.id;
        } else {
          book.route = book.id;
        }

        book.changesRequested = (book.status === "ChangesRequested");

        if (this.user.is_late_unproven && book.status === "Available" && 
        book.stats.looking_for_reviews === 0 && 
        book.stats.holding_unproven_reviews) {
          book.status = "HoldingUnproven"
        }

        if (this.user.is_vp_suspended_author) {
          book.is_vp_suspended = true
        }

        book.isCompleted = false;
      }
      const assignments = this.user.assignments;
      for (const a in assignments) {
        const assignment = assignments[a];
        assignment.route = assignment.id;
        if (
          assignment.status === "Approved" ||
          assignment.status === "PendingApproval" ||
          assignment.status === "ActionApproved"
        ) {
          assignment.isCompleted = true;
          assignment.dueSoon = false;
          assignment.actionRequested = false;
          if (assignment.review_issue) {
            assignment.showActionInformation = assignment.review_issue.request_inform;
          }
        } else if (assignment.status === "ActionRequested") {
          assignment.isCompleted = true;
          assignment.dueSoon = false;
          assignment.actionRequested = true;
          assignment.showActionInformation = false;
        } 
        else if (assignment.status === "CouldNotVerify") {
          assignment.isCompleted = true;
          assignment.dueSoon = false;
          assignment.actionRequested = false;
          assignment.showActionInformation = true;
        }else {
          assignment.isCompleted = false;
          assignment.actionRequested = false;
          assignment.showActionInformation = false;
          if (this.dueSoon(assignment)) {
            assignment.dueSoon = true;
          }
        }
        assignment.changesRequested = (assignment.status === "Rejected");
        
      }

      this.sections[0].pages = this.user.books;
      this.sections[1].pages = this.user.assignments.slice(0, 20);

      if (this.user.memberType === "friend") { //|| this.user.is_athlete || this.user.memberType === 'free'
        this.sections.shift();
      }

      // console.log("pages", this.sections[0].pages);
    },
    dueSoon(assignment) {
      const now = new Date()
      const dueDate = new Date(
        assignment.due_at.replace(/-/g, "/")
        );
        const startTime = dueDate.getTime() - dueDate.getTimezoneOffset() * 60 * 1000;

      const dueSoonCutoff = new Date(Math.round(
        (startTime - (24 * 60 * 1000))/(60*1000))*60*1000
      );

      return (now >= dueSoonCutoff); //(now <= dueDate) && 
    }
  },
  watch: {
    $route(to, from) {
      this.currentRoute = to.path;
    },
  },
  async created() {
    if (document.location.href.indexOf("/gate") !== -1) {
      return;
    }

    this.user = await Back.user();
    this.allowedCountries =  await Back.getAmazonDomains();
    this.frontendSettings = await Back.getFrontendSettings();
      this.readingLimit = this.frontendSettings.active_assignments_limit
      this.weeklyReadingLimit = this.frontendSettings.weekly_reading_limit
      this.reviewSearchLimit = this.frontendSettings.review_search_limit
    this.reviewIssues = await Back.getReviewIssues();
    this.genres = await Back.genres();
    this.languages = await Back.languages();
    this.currentRoute = this.$router.currentRoute;

    if (this.user.memberType !== "free") {
      this.sections.push({
        title: "Social",
        name: "social",
        routing: "assignments",
        icon: "forum",
        pages: [],
      });
    }

    if (this.user.memberType !== "friend") {
      this.sections.push({
        title: "Help",
        name: "help",
        routing: "assignments",
        icon: "help",
        pages: [],
      });
    }

    if (!this.user) {
      window.location.href = process.env.VUE_APP_ACCOUNT_URL + "/login";
      return;
    }
// console.log(this.user)
    this.$store.commit("handshake", this.user);
    this.$store.commit("setCountries", this.allowedCountries);
    this.$store.commit("setReviewIssues", this.reviewIssues);
    this.$store.commit("setReadingLimit", this.readingLimit || 2);
    this.$store.commit("setWeeklyReadingLimit", this.weeklyReadingLimit || 10);
    this.$store.commit("setReviewSearchLimit", this.reviewSearchLimit || 6);
    this.$store.commit("setGenres", this.genres);
    this.$store.commit("setLanguages", this.languages);
    this.loadPages();

    Bus.$on("UserChanged", async () => {
      this.user = await Back.user();

      this.$store.commit("handshake", this.user);
      this.loadPages();
    });

    var hasLiveBook = false;
    var totalReviewsRequested = 0;
    for (const book of this.user.books) {
      if (book.status === "Available" || book.status === "HoldingUnproven") {
        hasLiveBook = true;
      }

      totalReviewsRequested += book.stats.looking_for_reviews + book.stats.in_progress_reviews + book.stats.total_reviews;
    }

    if (this.user.memberType) {
      window.Intercom("boot", {
        app_id: process.env.VUE_APP_INTERCOM_ID,
        email: this.user.email,
        name: this.user.name,
        has_live_book: hasLiveBook,
        holding_unproven: this.user.is_late_unproven || false,
        requested_first_review: totalReviewsRequested>=1,
        requested_second_review: totalReviewsRequested>=2,
      });
    }
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: ($top-bar-height - 1) 0 0 0;
  border-top: 3px solid darken($color-sidebar, 4%);
  display: flex;
  flex-direction: column;
  height: 100%;
  background: darken($color-sidebar, 3%);
}

.app-sections {
  width: 100%;
  background: darken($color-sidebar, 3%);
  max-height: 83%;
  margin-top: 10px;
  padding: 12px 0px 12px 0px;
  overflow-y: scroll;
}
::-webkit-scrollbar {
  width: 0px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

.settings-section {
  margin-top: auto;
  padding-bottom: 20px;
}
</style>